<mat-card appearance="outlined">
	<p mat-card-title>Podsumowanie płatności</p>
	<mat-card-content>
		<table [dataSource]="dataSource" class="w-100" mat-table>
			<ng-container matColumnDef="paymentName">
				<th *matHeaderCellDef mat-header-cell>Nazwa płatności</th>
				<td
					*matCellDef="let element"
					[ngClass]="{
						'text-secondary text-decoration-line-through': element.disable,
					}"
					mat-cell
				>
					{{ element.name }}
				</td>
			</ng-container>

			<ng-container matColumnDef="price">
				<th *matHeaderCellDef mat-header-cell>Kwota</th>
				<td
					[ngClass]="{
						'text-secondary text-decoration-line-through': element.disable,
					}"
					*matCellDef="let element"
					mat-cell
				>
					{{ element.value | price }} PLN
				</td>
			</ng-container>

			<tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
			<tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
		</table>
	</mat-card-content>
</mat-card>
